import gql from "graphql-tag";
import graphqlClient, { fragments } from "@/http/graphql/inside";

const GET_TAGS = `
	tags {
		...Tag
	}
`;

export default {
	init() {},

	getTags(payload = {}) {
		const queryOptions = {
			query: gql`query Tags {
				${GET_TAGS}
			}
			${fragments.Tag}
			`
		};
		if (payload.fetchPolicy) {
			queryOptions.fetchPolicy = payload.fetchPolicy;
		}
		return graphqlClient.query(queryOptions).then(response => ({ tags: response.data.tags }));
	}
};
